import { useLocation } from 'react-router-dom'
import { useAppDispatch } from '../../app/hooks'
import {
  fetchPatientsAsync,
  setPatientSearchQueryValue,
} from '../patients/patientsSlice'
import SelectableSearch from './selectedtableseacrh'
import { opdRoute, opdSearchOptions } from './constant'
import KeycloakService from '../../utils/keycloakService'
import { ADMIN_EXPORT_DATA } from '../../utils/roles'
import ExportButton from '../../components/ExportButton'
const OPDSearch = ({
  onSearch,
  onCreateVisit,
  thopId,
  rowData,
  patientList,
}: {
  onSearch?: (query: string, param: string) => void
  onCreateVisit: () => void
  thopId: any
  rowData?: any[]
  patientList?: any[]
}) => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const handleSearch = (query: string, param: string) => {
    let q = ''
    switch (query) {
      case 'ID':
        q = 'identifier'
        break
    }
    dispatch(setPatientSearchQueryValue({ query: q, value: param }))
    dispatch(fetchPatientsAsync())
    onSearch?.(q, param)
  }

  return (
    <div className='patient-filter-btn opd-search-padding'>
      <ExportButton
        data={rowData}
        disabled={
          (!KeycloakService?.hasRole([ADMIN_EXPORT_DATA]) &&
            rowData?.length === 0) ||
          (patientList && patientList?.length <= 1)
        }
      />
      <div className='patient-search opd-search-padding'>
        <SelectableSearch
          items={opdSearchOptions}
          onSearch={handleSearch}
          thopId={thopId}
        />
      </div>
      {location?.pathname === opdRoute && (
        <div>
          <button
            className='btn btn-primaryBtn visit-margin-content'
            onClick={onCreateVisit}
          >
            Create Visit
          </button>
        </div>
      )}
    </div>
  )
}

export default OPDSearch
